<template>
  <report-list
    :type="type"
    :reportService="reportService"
  ></report-list>
</template>

<script>
  import ReportList from '@/components/Common/Report/ReportList'
  import reportService from '@/services/slotting/report'

  export default {
    created () {
      this.$store.commit('UPDATE_TITLE', 'Analytics')
    },

    components: {
      ReportList
    },

    data () {
      return {
        type: 'slotting',
        reportService: reportService
      }
    }
  }
</script>

<style lang="stylus">
  .clickable
    tr:hover
      cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/Slotting/Reports.vue